import { LocalNotifications, LocalNotificationSchema } from "@capacitor/local-notifications"
import moment from "moment"
import ICaloriasDia from "../interfaces/ICaloriasDia"
import IDatosIniciales from "../interfaces/IDatosIniciales"
import { get, post } from "../Rest"
import db from "./Database"

export const LOCAL_CONFIG = {
  months : 'enero,febrero,marzo,abril,mayo,junio,julio,agosto,septiembre,octubre,noviembre,diciembre'.split(','),
  monthsShort : 'ene,feb,mar,abr,may,jun,jul,ago,sep,oct,nov,dic'.split(','),
  monthsParseExact : true,
  weekdays : 'domingo,lunes,martes,miércoles,jueves,viernes,sábado,domingo'.split(','),
  weekdaysShort : 'dom,lun,mar,mie,jue,vie,sab'.split(','),
  weekdaysMin : 'Do,Lu,Ma,Mi,Ju,Vi,Sa'.split(',')
}

export async function sync_calorias_dia(datos_iniciales?:IDatosIniciales){
    if(datos_iniciales && datos_iniciales.id && window.navigator.onLine){
      const items = await db.calorias_dia.filter(f => !f.id).toArray()
      const items_del = await db.calorias_dia.filter(f => f.id=="-1").toArray()
      const response_items = await post("sync_calorias_dia/"+datos_iniciales.id,{items,items_del})
      await db.calorias_dia.clear()
      if(response_items && response_items.length){
        await db.calorias_dia.bulkPut(response_items)
      }
    }
}

export async function clearAlarms(){
  const alarmas = await LocalNotifications.getPending()
  if(alarmas.notifications.length > 0){
    await LocalNotifications.cancel(alarmas)
  }
}

export async function updateAlarma(){
  await LocalNotifications.requestPermissions()
  const permisions = await LocalNotifications.checkPermissions()
  if(permisions.display !== "denied"){
    const alarma = await db.alarmas.toArray()
    const datos_iniciales = await db.datos_iniciales.toArray()
    const calorias_dia = await db.calorias_dia.filter(c => moment(c.fecha).isSameOrAfter(moment().startOf('day'))&&parseInt(c.id)>0).toArray()
    await clearAlarms()
      if(alarma.length > 0 && datos_iniciales.length > 0 && parseInt(alarma[0].activo)>0){
        //Establece las alarmas
        setAlarmas(alarma[0],datos_iniciales[0],calorias_dia)
      }
    }
}

//Setea cada alarma
async function setAlarmas(alarma:any,datos_iniciales:IDatosIniciales,calorias_dia:Array<ICaloriasDia>){
  //Set alarmas
  const dias_alarma = formatMensajeCalorias(calorias_dia)
  const json_alarma = [] as Array<LocalNotificationSchema>
  let cont = 1
  for(let fecha in dias_alarma){
    for(let cod in dias_alarma[fecha]){
      if(moment(fecha+" "+alarma[cod]).isAfter(moment())){
        json_alarma.push({
          id:cont++,
          title: "Recuerda tu "+horarios_comida.find(h => h.cod === cod)?.name,
          body: dias_alarma[fecha][cod],
          sound: "sonido_acromax.wav",
          smallIcon:"ic_stat_name",
          schedule: {
            at: moment(fecha+" "+alarma[cod]).toDate()
          }
        })
      }
    }
  }
  json_alarma.push({
    id:cont,
    title:"Registra tu PESO",
    body:"Ya ha pasado una semana, te recomendamos registrar tu peso",
    smallIcon:'res://drawable/ic_stat_name',
    schedule: {
      every: 'week',
      at: moment().startOf('isoWeek').add(1, 'week').startOf("day").add(10,"hours").toDate()
    }
  })
  await LocalNotifications.schedule({
    notifications:json_alarma
  })
}

export function formatMensajeCalorias(calorias_dia:Array<ICaloriasDia>){
  const dias_alarma = {} as any
  calorias_dia.forEach(cal => {
    const horario = horarios_comida.find(h => h.name == cal.horario_comida)
    if(horario){
      if(!dias_alarma[cal.fecha]){
        dias_alarma[cal.fecha] = {}
      }
      if(!dias_alarma[cal.fecha][horario.cod]){
        dias_alarma[cal.fecha][horario.cod] = ""
      }
      dias_alarma[cal.fecha][horario.cod]+=cal.detalle+" x"+(cal.cantidad||1)+"\n"
    }
  })
  return dias_alarma
}

export const horarios_comida = [
  {name:"Desayuno",cod:"desayuno"},
  {name:"Media mañana",cod:"media_manana"},
  {name:"Almuerzo",cod:"almuerzo"},
  {name:"Media tarde",cod:"media_tarde"},
  {name:"Cena",cod:"cena"}
] as Array<IHorarioComida>

export interface IHorarioComida{
  name:string,
  cod:string
}

export const syncAlimentos = async () => {
  if(navigator.onLine){ //Actualiza catálogo si existe internet
      const user = await db.usuarios.toArray()
      const productos = await get("cat/alimentos?user="+user[0].id)
      await db.alimentos.bulkPut(productos)
  }
}

export function soloNumeros(e:any){
  var tecla = (document.all) ? e.keyCode : e.which;

  //Tecla de retroceso para borrar, siempre la permite
  if (tecla == 8 || tecla == 9 || tecla == 13 || tecla == 16 || tecla == 17 || tecla == 18 || tecla == 32) {
      return true;
  }

  // Patron de entrada, en este caso solo acepta numeros y letras
  var patron = /[0-9]/;
  var tecla_final = String.fromCharCode(tecla);
  if(!patron.test(tecla_final)){
    e.preventDefault();
    return false;
  }
  return true;
}

export function soloTexto(e:any){
    var tecla = (document.all) ? e.keyCode : e.which;

    //Tecla de retroceso para borrar, siempre la permite
    if (tecla == 8 || tecla == 9 || tecla == 13 || tecla == 16 || tecla == 17 || tecla == 18 || tecla == 32) {
        return true;
    }

    // Patron de entrada, en este caso solo acepta numeros y letras
    var patron = /[A-Za-záéíóúÁÉÍÓÚñÑ]/;
    var tecla_final = String.fromCharCode(tecla);
    if(!patron.test(tecla_final)){
      e.preventDefault();
      return false;
    }
    return true;
}

export function soloNumerosLetras(e:any){
    var tecla = (document.all) ? e.keyCode : e.which;

    //Tecla de retroceso para borrar, siempre la permite
    if (tecla == 8 || tecla == 9 || tecla == 13 || tecla == 16 || tecla == 17 || tecla == 18 || tecla == 32) {
        return true;
    }

    // Patron de entrada, en este caso solo acepta numeros y letras
    var patron = /[A-Za-z0-9\-_.]/;
    var tecla_final = String.fromCharCode(tecla);
    if(!patron.test(tecla_final)){
      e.preventDefault();
      return false;
    }
    return true;
}